export default __webpack_public_path__ + "static/media/Cv_Indiveri_Esteban.cf0eae29.pdf";